export const TEMPLATE_BULK_IMPORT_COLLAPSED_KEY =
  'template-bulk-import:section-collapsed';
